import React, { useState } from 'react';

const width = {
  width: '100%'
};

function HandleError({
  error,
  message,
  details,
  title
}) {
  const [showDetail, setShowDetail] = useState(false);
  const messageToShow = message || (error ? error.message : 'Error');
  const detailToShow = details || (error ? error.stack : '');
  const titleToShow = title || 'Error!';
  return (
    <section>
      <br />
      <div className="alert alert-warning text-left" style={width}>
        <h3>
          {titleToShow}
        </h3>
        <p>
          <i className="fa fa-exclamation-triangle" aria-hidden="true" />
          &nbsp; An error occured while processing the request.
        </p>
        <p>
          {messageToShow}
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => setShowDetail(!showDetail)}
            className="button btn-danger"
          >
            {!showDetail && <span>Show Details</span>}
            {showDetail && <span>Hide Details</span>}
          </button>
          {' '}
        </p>
        {showDetail
          && (
            <div id="divErrorDetails">
              <h4>Details:</h4>
              <p>{detailToShow}</p>
            </div>
          )}
      </div>
    </section>
  );
};

export default HandleError;
